<template>
  <span v-if="enabled" class="support-button">
    <v-list-item
      v-if="mode === 'menu'"
      class="list-item-menu support-button__menu"
      :href="supportHref"
      target="_blank"
      rel="noopener noreferrer"
      @mousedown="prepareSupportHref"
      @focus="prepareSupportHref"
      @click.stop="handleClick"
    >
      <v-list-item-title class="list-item-title-menu">
        Acionar suporte
      </v-list-item-title>
    </v-list-item>

    <v-list-item
      v-else-if="mode === 'mobile'"
      class="support-button__mobile"
      :href="supportHref"
      target="_blank"
      rel="noopener noreferrer"
      @mousedown="prepareSupportHref"
      @focus="prepareSupportHref"
      @click.stop="handleClick"
    >
      <v-list-item-title>
        <v-icon>mdi-lifebuoy</v-icon> Acionar suporte
      </v-list-item-title>
    </v-list-item>

    <v-btn
      v-else
      class="support-button__login"
      outlined
      color="primary"
      block
      :href="supportHref"
      target="_blank"
      rel="noopener noreferrer"
      @mousedown="prepareSupportHref"
      @focus="prepareSupportHref"
      @click.stop="handleClick"
    >
      <v-icon left>mdi-lifebuoy</v-icon>
      Acionar suporte
    </v-btn>
  </span>
</template>

<script>
import {
  isSupportEnabled,
  saveSupportContextSnapshot,
} from "../services/supportContext";
import { suporteApi } from "../services/supportApi";

export default {
  name: "SupportButton",
  props: {
    mode: {
      type: String,
      default: "login",
    },
    origin: {
      type: String,
      default: "area_logada",
    },
  },
  data() {
    return {
      supportHref: "",
      publicAvailability: null,
    };
  },
  computed: {
    enabled() {
      return isSupportEnabled(this.$store.state, this.publicAvailability);
    },
  },
  watch: {
    enabled(value) {
      if (value && !this.supportHref) {
        this.prepareSupportHref();
      }
    },
  },
  mounted() {
    this.loadPublicAvailability();
    if (this.enabled) {
      this.prepareSupportHref();
    }
  },
  methods: {
    loadPublicAvailability() {
      if (this.$store.state.isAuthenticated) {
        return;
      }

      suporteApi
        .habilitado()
        .then(({ data }) => {
          this.publicAvailability = !!(data && data.acionarSuporte);
        })
        .catch(() => {
          this.publicAvailability = false;
        });
    },
    prepareSupportHref() {
      const snapshot = saveSupportContextSnapshot(this, this.origin);
      const route = this.$router.resolve({
        name: "support.open",
        query: {
          contextKey: snapshot.key,
        },
      });

      this.supportHref = new URL(route.href, window.location.origin).toString();
      return this.supportHref;
    },
    handleClick() {
      if (!this.supportHref) {
        this.prepareSupportHref();
      }
      this.$emit("open");
    },
  },
};
</script>

<style lang="scss" scoped>
.support-button {
  display: block;
}

.support-button__login {
  background: #fff !important;
  border-color: #1f2937 !important;
  color: #1f2937 !important;
  margin-top: 16px;
  min-height: 44px !important;

  .v-icon {
    color: #1f2937 !important;
  }
}

.support-button__menu {
  color: #1f2937 !important;
  cursor: pointer;

  .list-item-title-menu {
    color: #1f2937 !important;
  }
}

.support-button__mobile {
  color: #1f2937 !important;

  .v-icon {
    color: #1f2937 !important;
  }
}
</style>
